import React from 'react';

/**
 * EditScheduledGameModal
 *
 * Props:
 *   game      — local draft of the game being edited (state owned by SchedulePanel)
 *   onChange  — (updatedGame) => void
 *   onSave    — () => void
 *   onClose   — () => void
 */
const EditScheduledGameModal = ({ game, onChange, onSave, onClose }) => {
    if (!game) return null;

    const setDate = (e) => {
        const newDate = e.target.value;
        onChange({
            ...game,
            game_date: newDate
                ? `${newDate}T${game.game_date?.slice(11, 19) || '00:00:00'}`
                : game.game_date,
        });
    };

    const setTime = (e) => {
        const newTime = e.target.value;
        onChange({
            ...game,
            game_date: game.game_date
                ? `${game.game_date.slice(0, 10)}T${newTime}:00`
                : `${new Date().toISOString().slice(0, 10)}T${newTime}:00`,
        });
    };

    const setCourt = (e) =>
        onChange({ ...game, court: e.target.value || null });

    return (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-[60]">
            <div className="bg-white dark:bg-gray-800 rounded-3xl shadow-xl max-w-md w-full overflow-hidden">

                <div className="px-6 pt-6 pb-4 border-b dark:border-gray-700">
                    <h3 className="text-2xl font-bold text-gray-900 dark:text-white">Edit Game</h3>
                    <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                        {game.team1?.name} vs {game.team2?.name}
                    </p>
                </div>

                <div className="p-6 space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Game Date
                        </label>
                        <input
                            type="date"
                            value={game.game_date?.slice(0, 10) || ''}
                            onChange={setDate}
                            className="w-full border dark:border-gray-600 rounded-xl px-4 py-3
                                       bg-white dark:bg-gray-700 text-gray-900 dark:text-white
                                       focus:ring-2 focus:ring-orange-500 focus:outline-none"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Game Time
                        </label>
                        <input
                            type="time"
                            value={game.game_date?.slice(11, 16) || ''}
                            onChange={setTime}
                            className="w-full border dark:border-gray-600 rounded-xl px-4 py-3
                                       bg-white dark:bg-gray-700 text-gray-900 dark:text-white
                                       focus:ring-2 focus:ring-orange-500 focus:outline-none"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Court
                        </label>
                        <select
                            value={game.court || ''}
                            onChange={setCourt}
                            className="w-full border dark:border-gray-600 rounded-xl px-4 py-3
                                       bg-white dark:bg-gray-700 text-gray-900 dark:text-white
                                       focus:ring-2 focus:ring-orange-500 focus:outline-none"
                        >
                            <option value="">No court assigned</option>
                            {[1, 2, 3, 4, 5].map(n => (
                                <option key={n} value={`Court ${n}`}>{n}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="flex border-t dark:border-gray-700 p-4 gap-3">
                    <button
                        onClick={onClose}
                        className="flex-1 py-3 text-gray-700 dark:text-gray-300 font-medium
                                   border dark:border-gray-600 rounded-2xl
                                   hover:bg-gray-100 dark:hover:bg-gray-700 transition"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onSave}
                        className="flex-1 py-3 bg-orange-600 hover:bg-orange-700
                                   text-white font-semibold rounded-2xl transition"
                    >
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditScheduledGameModal;